<template>
	<div id="app">
		<notifications />
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'app'
	}
</script>

<style lang="scss">
	@import "~bootstrap/scss/bootstrap";
	@import "./assets/styles/custom.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue